"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Direction;
(function (Direction) {
    Direction[Direction["Horizontal"] = 0] = "Horizontal";
    Direction[Direction["Vertical"] = 1] = "Vertical";
})(Direction || (Direction = {}));
function makePolygons(collection, index, interiorRings, originalIdField) {
    index.resetProcessedState();
    var outputCollection = {
        type: "FeatureCollection",
        features: [],
    };
    var nextExteriorRing = index.getNextExteriorRing();
    var _loop_1 = function () {
        var event_1 = nextExteriorRing;
        var prev = null;
        var addedPositions = {};
        var duplicateCoordinateLocations = [];
        var coordinates = [event_1.position];
        var hasEventOffEdge = false;
        var collectedFeatureIds = [];
        var _loop_2 = function () {
            if (coordinates.length > 1 &&
                event_1.position[0] === nextExteriorRing.position[0] &&
                event_1.position[1] === nextExteriorRing.position[1]) {
                return "break";
            }
            hasEventOffEdge = hasEventOffEdge || event_1.trailingCoordinates.length > 0;
            index.recordTouchedPolygons([event_1.polygonId]);
            if (collectedFeatureIds.indexOf(event_1.featureId) === -1) {
                collectedFeatureIds.push(event_1.featureId);
            }
            var key = event_1.position.join(",");
            if (addedPositions[key]) {
                duplicateCoordinateLocations.push(addedPositions[key].index, coordinates.length - 1);
                addedPositions[key].count++;
                if (addedPositions[key].count > 3) {
                    throw new Error("Looping through the same path");
                }
            }
            else {
                addedPositions[key] = {
                    index: coordinates.length - 1,
                    count: 1,
                };
            }
            var destination = pickNext(event_1, index);
            if (event_1.next.trailingCoordinates.length === 0 &&
                (event_1.position[0] === destination.position[0] ||
                    event_1.position[1] === destination.position[1])) {
                var _a = eventsInPlane(event_1, destination, index), behind_1 = _a.behind, inPath = _a.inPath;
                if (!behind_1.find(function (e) {
                    return e.polygonId === (event_1 === null || event_1 === void 0 ? void 0 : event_1.polygonId) ||
                        e.polygonId === (prev === null || prev === void 0 ? void 0 : prev.polygonId) ||
                        (addedPositions[e.position.join(",")] &&
                            !(e !== prev && behind_1.length === 1 && e === nextExteriorRing));
                })) {
                    if (behind_1.length > 1 &&
                        behind_1[0].position[0] === behind_1[1].position[0] &&
                        behind_1[0].position[1] === behind_1[1].position[1]) {
                        var commonPlane_1 = event_1.position[0] === behind_1[0].position[0] ? 0 : 1;
                        behind_1 = __spreadArrays(behind_1
                            .slice(0, 2)
                            .filter(function (e) {
                            return e.next.trailingCoordinates.length > 0 ||
                                e.next.position[commonPlane_1] !==
                                    behind_1[0].position[commonPlane_1];
                        }), behind_1.slice(2));
                    }
                    if (behind_1.length &&
                        behind_1.length % 2 !== 0) {
                        coordinates.push(behind_1[0].position);
                        prev = event_1;
                        event_1 = behind_1[0];
                        return "continue";
                    }
                }
                if (inPath.length) {
                    coordinates.push(inPath[0].position);
                    prev = event_1;
                    event_1 = inPath[0];
                    return "continue";
                }
            }
            coordinates.push.apply(coordinates, event_1.next.trailingCoordinates);
            if (!duplicateCoPlanarEvents(event_1, destination)) {
                coordinates.push(destination.position);
            }
            prev = event_1;
            event_1 = destination;
        };
        while (event_1) {
            var state_1 = _loop_2();
            if (state_1 === "break")
                break;
        }
        event_1 = null;
        prev = null;
        if (hasEventOffEdge) {
            var interior = [];
            for (var _i = 0, _a = index.getTouchedPolygonIds(); _i < _a.length; _i++) {
                var id = _a[_i];
                interior.push.apply(interior, interiorRings[id]);
            }
            var properties = collection.features[collectedFeatureIds[0]].properties;
            var segments = [];
            if (duplicateCoordinateLocations.length) {
                duplicateCoordinateLocations.sort(function (a, b) { return a - b; });
                for (var i = 0; i < duplicateCoordinateLocations.length; i++) {
                    segments.push(coordinates.slice(i === 0 ? 0 : duplicateCoordinateLocations[i - 1], duplicateCoordinateLocations[i] + 1));
                    if (i === duplicateCoordinateLocations.length - 1) {
                        segments.push(coordinates.slice(duplicateCoordinateLocations[i] + 1));
                    }
                }
                while (segments.length) {
                    var coordinates_1 = [];
                    if (segments.length === 1) {
                        coordinates_1 = segments.pop();
                    }
                    else if (segments.length > 1) {
                        coordinates_1 = __spreadArrays(segments.shift(), segments.pop());
                    }
                    var feature = {
                        type: "Feature",
                        properties: properties,
                        geometry: {
                            type: "Polygon",
                            coordinates: __spreadArrays([
                                coordinates_1
                            ], interior),
                        },
                    };
                    outputCollection.features.push(feature);
                }
            }
            else {
                var feature = {
                    type: "Feature",
                    properties: properties,
                    geometry: {
                        type: "Polygon",
                        coordinates: __spreadArrays([
                            coordinates
                        ], interior),
                    },
                };
                outputCollection.features.push(feature);
            }
        }
        index.markTouchedPolygonsAsProcessed();
        nextExteriorRing = index.getNextExteriorRing();
    };
    while (nextExteriorRing) {
        _loop_1();
    }
    if (originalIdField) {
        var byId = outputCollection.features.reduce(function (lookup, feature) {
            var _a;
            if (!feature.properties) {
                throw new Error("originalIdField supplied but properties not present on feature");
            }
            var existing = lookup[feature.properties[originalIdField].toString()];
            if (existing) {
                if (existing.geometry.type === "Polygon") {
                    existing.geometry.type = "MultiPolygon";
                    existing.geometry.coordinates = [existing.geometry.coordinates];
                }
                if (existing.geometry.type === "MultiPolygon") {
                    if (feature.geometry.type === "MultiPolygon") {
                        (_a = existing.geometry.coordinates).push.apply(_a, feature.geometry.coordinates);
                    }
                    else {
                        existing.geometry.coordinates.push(feature.geometry.coordinates);
                    }
                }
            }
            else {
                lookup[feature.properties[originalIdField].toString()] = feature;
            }
            return lookup;
        }, {});
        outputCollection.features = Object.values(byId);
    }
    return outputCollection;
}
exports.default = makePolygons;
function duplicateCoPlanarEvents(start, destination) {
    if (destination.trailingCoordinates.length ||
        destination.next.trailingCoordinates) {
        return false;
    }
    var straightX = start.position[0] === destination.position[0] &&
        destination.position[0] === destination.next.position[0];
    var straightY = start.position[1] === destination.position[1] &&
        destination.position[1] === destination.next.position[1];
    return straightX || straightY;
}
function pickNext(origin, index) {
    var overlapping = index
        .getByPosition(origin.next.position)
        .filter(function (e) { return e.polygonId !== origin.polygonId; });
    if (overlapping.length === 0) {
        return origin.next;
    }
    else {
        var nextEvent = overlapping.sort(function (a, b) {
            if (a.isNinetyDegreeCorner && !b.isNinetyDegreeCorner) {
                return 1;
            }
            else if (b.isNinetyDegreeCorner && !a.isNinetyDegreeCorner) {
                return -1;
            }
            else {
                return 0;
            }
        })[0];
        return nextEvent;
    }
}
function eventsInPlane(start, destination, index) {
    var direction = start.position[0] === destination.position[0]
        ? Direction.Vertical
        : Direction.Horizontal;
    var vary = direction === Direction.Vertical ? 1 : 0;
    var events = direction === Direction.Vertical
        ? index.getByX(start.position)
        : index.getByY(start.position);
    var ascending = start.position[vary] < destination.position[vary];
    return {
        behind: events
            .filter(function (e) {
            return ascending
                ? e.position[vary] < start.position[vary]
                : e.position[vary] > start.position[vary];
        })
            .sort(function (a, b) {
            if (ascending) {
                return b.position[vary] - a.position[vary];
            }
            else {
                return a.position[vary] - b.position[vary];
            }
        }),
        inPath: events
            .filter(function (e) {
            return ascending
                ? e.position[vary] > start.position[vary] &&
                    e.position[vary] < destination.position[vary]
                : e.position[vary] < start.position[vary] &&
                    e.position[vary] > destination.position[vary];
        })
            .sort(function (a, b) {
            if (ascending) {
                return a.position[vary] - b.position[vary];
            }
            else {
                return b.position[vary] - a.position[vary];
            }
        }),
    };
}
